import { render } from "./FAQScreen.vue?vue&type=template&id=0d42ae62&scoped=true"
import script from "./FAQScreen.vue?vue&type=script&lang=js"
export * from "./FAQScreen.vue?vue&type=script&lang=js"

import "./FAQScreen.vue?vue&type=style&index=0&id=0d42ae62&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d42ae62"]])

export default __exports__